const nestPath = process.env.REACT_APP_NEST_API_URL;

export const expertJoinPath = {
    joinDefualt: `${nestPath}/v3/user/join/app`, // 일반 회원가입
    joinExpert: `${nestPath}/v3/user/join/app/expert`, // 전문가 회원가입
    applicationExpert: `${nestPath}/user/expert/register`, // 전문가 신청
    uploadProfileImage: `${nestPath}/user/expert/profile`, // 프로필 이미지 업로드
    matchPartner: `${nestPath}/user/expert/partner-code`, // 전문가 본인 추천인 코드 중복검사
    searchOffice: `${nestPath}/agent-offices`, // 공인중개사 조회
    searchLocation: `${nestPath}/building-register/search`, // 소재지 조회
};
